export default __webpack_public_path__ + "static/media/businessloans.a560b063.png";